import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useLicencia } from '../context/LicenciaContext';

/**
 * Bloquea la app si no hay suscripción activa.
 * - Superadmin: pasa siempre.
 * - Estado 'ok': muestra la app normalmente.
 * - Estado 'sin_licencia' o 'inactiva': pantalla de bloqueo con mensaje de contacto.
 */
export default function LicenciaGuard({ children }) {
  const { estado } = useLicencia();
  const navigate = useNavigate();

  if (estado === 'cargando') {
    return (
      <div style={overlayStyle}>
        <div style={spinnerStyle} />
        <p style={{ color: 'var(--text-3)', marginTop: 16, fontSize: 14 }}>Verificando licencia...</p>
      </div>
    );
  }

  if (estado === 'ok') return children;

  // ── Pantalla de bloqueo ────────────────────────────────────────────────────
  const sinLicencia = estado === 'sin_licencia';

  return (
    <div style={overlayStyle}>
      <div style={cardStyle}>
        <div style={{ fontSize: 48, marginBottom: 16 }}>🔒</div>

        <h1 style={{ margin: '0 0 6px', fontSize: 24, fontWeight: 800, color: 'var(--text-1)' }}>Prestam.io</h1>
        <h2 style={{ margin: '0 0 10px', fontSize: 15, fontWeight: 600, color: sinLicencia ? '#fbbf24' : '#f87171' }}>
          {sinLicencia ? 'Sin suscripción activa' : 'Suscripción vencida o inactiva'}
        </h2>
        <p style={{ margin: 0, color: 'var(--text-3)', fontSize: 13, lineHeight: 1.6 }}>
          {sinLicencia
            ? 'Tu empresa no tiene un plan activo en Prestam.io. Contacta al administrador para activar tu suscripción.'
            : 'Tu suscripción está vencida o fue cancelada. Contacta al administrador de Prestam.io para renovarla.'}
        </p>

        <div style={{ borderTop: '1px solid var(--border)', margin: '24px 0' }} />

        <a
          href="mailto:soporte@prestam.io?subject=Activación%20de%20suscripción"
          style={{
            display: 'block', padding: '12px 0', borderRadius: 10,
            background: '#6366f1', color: '#fff', textDecoration: 'none',
            fontWeight: 700, fontSize: 14, textAlign: 'center', marginBottom: 12,
          }}
        >
          Contactar soporte Prestam.io
        </a>

        <div style={{ background: 'var(--bg-app)', borderRadius: 10, padding: '14px 16px', fontSize: 13, color: 'var(--text-3)', lineHeight: 1.6 }}>
          Si ya tienes una suscripción activa y este mensaje persiste, cierra sesión e intenta de nuevo.
          Si el problema continúa, escribe a <strong style={{ color: 'var(--text-2)' }}>soporte@prestam.io</strong>.
        </div>

        <button
          onClick={() => { localStorage.removeItem('saturnpro_token'); navigate('/login'); }}
          style={{ marginTop: 20, background: 'none', border: 'none', color: 'var(--text-4)', cursor: 'pointer', fontSize: 12, textDecoration: 'underline' }}
        >
          Cerrar sesión
        </button>
      </div>
    </div>
  );
}

const overlayStyle = {
  position: 'fixed', inset: 0,
  background: 'var(--bg-app)',
  display: 'flex', alignItems: 'center', justifyContent: 'center',
  zIndex: 9999, padding: 20,
};

const cardStyle = {
  background: 'var(--bg-card)',
  borderRadius: 20,
  padding: '40px 36px',
  width: '100%', maxWidth: 440,
  border: '1px solid var(--border)',
  textAlign: 'center',
  boxShadow: '0 25px 50px rgba(0,0,0,0.5)',
};

const spinnerStyle = {
  width: 36, height: 36, borderRadius: '50%',
  border: '3px solid var(--border)',
  borderTopColor: '#6366f1',
  animation: 'spin 0.8s linear infinite',
};

if (typeof document !== 'undefined' && !document.getElementById('licencia-spin')) {
  const s = document.createElement('style');
  s.id = 'licencia-spin';
  s.textContent = '@keyframes spin { to { transform: rotate(360deg); } }';
  document.head.appendChild(s);
}
